import { ScrollObserver, valueAtPercentage } from 'aatjs';

const cardsContainer = document.querySelector('.features-cards-list');
const cards = document.querySelectorAll('.features-cards-list__item');

if ( document.querySelector('.features-section') ) {
    if (window.innerWidth >= 768) {
        cardsContainer.style.setProperty('--cards-count', cards.length);
        cardsContainer.style.setProperty('--card-height', `${cards[0].clientHeight}px`);

        Array.from(cards).forEach((card, index) => {
            const offsetTop = 20 + index * 20;

            if (index === cards.length - 1) { return }

            const toScale = 1 - (cards.length - 1) * 0.1;
            const nextCard = cards[index + 1];
            const cardInner = card.querySelector('.features-cards-list__item-inner');

            ScrollObserver.Element(nextCard, {
                offsetTop,
                offsetBottom: window.innerHeight - card.clientHeight
            }).onScroll(({ percentageY }) => {
                cardInner.style.scale = valueAtPercentage({
                    from: 1,
                    to: toScale,
                    percentage: percentageY
                });
                cardInner.style.filter = `brightness(${valueAtPercentage({
                    from: 1,
                    to: 0.6,
                    percentage: percentageY
                })})`;
            });
        });
    }
}
